export default "__VITE_ASSET__45okGtkp__"